import { api } from './client';
import type { GroupKind, GroupPublic } from './types';
// Phase 2 트리 API는 groupsTree.ts에 분리. 기존 평면 CRUD 유지 (v1 호환).
export type { GroupTreeNode, MoveGroupInput, ReorderGroupsInput, GroupPublicV2 } from './groupsTree';
export { groupsTreeApi } from './groupsTree';

export interface GroupCreateInput {
  name: string;
  kind: GroupKind;
  color?: string;
  icon?: string;
  sortOrder?: number;
  /** Phase 2: 부모 그룹 id. 생략 시 루트. */
  parentId?: number | null;
  /** Phase 2: 형제 정렬 키. */
  orderIndex?: number;
}

export interface GroupUpdateInput {
  name?: string;
  color?: string | null;
  icon?: string | null;
  sortOrder?: number;
  /** Phase 2: 부모 그룹 id 변경. undefined = 변경 안 함, null = 루트로 이동. */
  parentId?: number | null;
  /** Phase 2: 형제 정렬 키 변경. */
  orderIndex?: number;
}

export const groupsApi = {
  list: (kind?: GroupKind) => {
    const qs = kind ? `?kind=${kind}` : '';
    return api.get<{ items: GroupPublic[] }>(`/api/groups${qs}`);
  },
  create: (body: GroupCreateInput) => api.post<GroupPublic>('/api/groups', body),
  update: (id: number, body: GroupUpdateInput) => api.patch<GroupPublic>(`/api/groups/${id}`, body),
  /** 기본 cascade=true — 소속 항목 함께 삭제. false로 전달 시 group_id=NULL로 유지. */
  remove: (id: number, cascade: boolean = true) =>
    api.del<{ ok: true }>(`/api/groups/${id}?cascade=${cascade}`),
  /**
   * 휴지통 그룹 복원 (soft-delete → 활성).
   * U52 restore API 연동. session 전용.
   */
  restore: (id: number) => api.post<{ ok: true }>(`/api/groups/${id}/restore`),
};
